import React, { Component } from 'react';
import { Card, Tree, Row } from 'antd';
import './TreeDirectory.less';

const { TreeNode } = Tree;

class TreeDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      expandedKeys: [],
      selectedKeys: [],
    };
  }

  componentDidMount() {
    const list = this.props.data;
    const { directoryUuid } = this.props;
    let expandedKeys = [];
    expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
    this.setState({ list, selectedKeys: [directoryUuid], expandedKeys });
  }

  componentWillReceiveProps(nextProps) {
    const list = nextProps.data;
    const { directoryUuid } = nextProps;
    let { expandedKeys } = this.state;
    if (list !== this.props.data) {
      expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
      expandedKeys = expandedKeys.filter((currentValue, index, arr) => {
        return arr.indexOf(currentValue) === index && currentValue;
      });
      this.setState({
        list,
        expandedKeys,
      });
    }

    if (directoryUuid !== this.props.directoryUuid) {
      this.setState({
        selectedKeys: [directoryUuid],
      });
    }
  }

  // 找到该目录的所有父级目录（及以上）
  getParentKey = (key, tree, grandKeys) => {
    let parentKey;
    const grandKey = grandKeys || [];
    tree.map(item => {
      if (item.children) {
        if (item.children.some(item1 => item1.uuid === key)) {
          grandKey.push(item.uuid);
          parentKey = grandKey;
        } else if (this.getParentKey(key, item.children)) {
          grandKey.push(item.uuid);
          parentKey = this.getParentKey(key, item.children, grandKey);
        }
      }
      return item;
    });
    return parentKey;
  };

  // 展开
  onExpand = (Key, e) => {
    this.setState({
      expandedKeys: Key,
    });
  };

  // 选中
  onSelect = (selectedKeys, e) => {
    this.setState({
      selectedKeys,
    });
    this.props.onSelect({
      uuid: e.selected ? e.node.props.dataRef.uuid : '',
      name: e.selected ? e.node.props.dataRef.name : '',
    });
  };

  titleItem = item => {
    return <span className="treeTitle">{item.name}</span>;
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={() => this.titleItem(item)} key={item.uuid} dataRef={item}>
            {() => this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={() => this.titleItem(item)} key={item.uuid} {...item} />;
    });
  };

  render() {
    const { list, selectedKeys, expandedKeys } = this.state;

    return (
      <Card
        style={{ padding: '10px', height: '100%' }}
        bodyStyle={{ padding: '0', height: '100%' }}
      >
        <Row type="flex" justify="end" />
        <Tree
          showLine
          onSelect={this.onSelect}
          selectedKeys={selectedKeys}
          onExpand={this.onExpand}
          expandedKeys={expandedKeys}
        >
          {() => this.renderTreeNodes(list || [])}
        </Tree>
      </Card>
    );
  }
}

export default TreeDirectory;



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetail/TreeDirectory.js